import { render, staticRenderFns } from "./DonutChart34Template.vue?vue&type=template&id=3960fdac&scoped=true"
import script from "./DonutChart34Template.vue?vue&type=script&lang=js"
export * from "./DonutChart34Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3960fdac",
  null
  
)

export default component.exports